var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53033 6.96967C1.23744 6.67678 0.762563 6.67678 0.46967 6.96967C0.176777 7.26256 0.176777 7.73744 0.46967 8.03033L4.96967 12.5303C5.26256 12.8232 5.73744 12.8232 6.03033 12.5303L17.0303 1.53033C17.3232 1.23744 17.3232 0.762563 17.0303 0.46967C16.7374 0.176777 16.2626 0.176777 15.9697 0.46967L5.5 10.9393L1.53033 6.96967Z",
    fill: "#4A4A49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/CheckMarkIcon.1ef99ae6be218097e907fff76245c66a.svg";
export { ForwardRef as ReactComponent };